import { useContext, createContext } from "react";
import { AuthSession, User } from "@/types/auth";

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
  startLogin: (email: string, organizationId?: string) => Promise<void>;
  verifyOtp: (email: string, otpCode: string) => Promise<void>;
  acceptSession: (session: AuthSession) => void;
  clearSession: () => void;
  logout: () => void;
  user: User | null;
  getAccessToken: () => Promise<string>;
  refreshAccessToken: () => Promise<string>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
